<template>
    <v-container grid-list-md fluid px-0 py-0 id="search-container">
        <v-layout wrap>
            <v-flex xs12 pa-0 >
                <v-parallax
                    :height="windowHeight"
                    :src="require('./assets/bg-tmp3.png')"
                >
                    <v-row
                        align="center"
                        justify="center"
                        class="marv-bg-fg"
                    >
                        <v-col
                            class="text-center"
                            cols="12"
                        >
                            <h1 class="text-h3 font-weight-light mb-4">
                                Protein Interface Clusters
                            </h1>
                            <h4 class="text-h6 font-weight-light mb-4">
                                Explore clusters of protein interfaces from the <a href="https://www.rcsb.org" target="_blank" rel="noopener">Protein Data Bank</a> using <a href="https://foldseek.com" target="_blank" rel="noopener">Foldseek-Interface</a>
                            </h4>
                            
                            <br>
                             
                            <v-tabs
                                class="search-select"
                                slider-size="1"
                                v-model="tab"
                                centered
                                background-color="transparent"
                                dark
                            >
                                <v-tab>Accession</v-tab>
                                <!-- <v-tab>Gene Ontology</v-tab> -->
                                <v-tab>Taxonomy</v-tab>
                                <v-tab>Structure</v-tab>
                                <v-tab>Cluster ID</v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="tab" style="padding: 1em;">
                                <v-tab-item>
                                    <div style="max-width: 400px; margin: 0 auto;">
                                        <div
                                        v-for="(accession, index) in queryAccessions"
                                        :key="index"
                                        style="display: flex; align-items: center; margin-bottom: 8px;"
                                    >
                                    <v-text-field
                                        outlined
                                        :hide-details="index === 0 ? (error == null) : true"
                                        :label="index === 0 ? 'PDB/UniProt Accession' : 'UniProt Accession'"
                                        v-model="queryAccessions[index]"
                                        :append-icon="index === 0 && inSearch ? $MDI.ProgressWrench : index === 0 ? $MDI.Magnify : ''"
                                        :disabled="inSearch"
                                        @click:append="index === 0 ? search() : null"
                                        @keyup.enter="search"
                                        @change="selectedExample = null"
                                        @keydown="error = null"
                                        :error="error != null && index === 0"
                                        :error-messages="error && index === 0 ? error : []"
                                        dark
                                        style="flex: 1;"
                                    />

                                    <v-btn
                                        v-if="index > 0"
                                        icon
                                        dark
                                        @click="queryAccessions.splice(index, 1)"
                                        style="margin-left: 4px;"
                                    >
                                        <v-icon>{{ $MDI.MinusBox }}</v-icon>
                                    </v-btn>
                                    </div>

                                    <div v-if="queryAccessions.length < 2 && queryAccessions[0]" style="margin-bottom: 16px; margin-top: 0px">
                                    <v-text-field
                                        outlined
                                        hide-details
                                        label="(Optional) UniProt Accession"
                                        v-model="queryAccessions[1]"
                                        :disabled="inSearch"
                                        @keyup.enter="search"
                                        @change="selectedExample = null"
                                        @keydown="error = null"
                                        :error="error != null"
                                        :error-messages="error ? error : []"
                                        dark
                                        style="flex: 1;"
                                    />
                                    </div>
                                </div>

                                <template>
                                    <h2 class="text-h6 mb-2">Examples</h2>
                                    <v-chip-group column dark v-model="selectedExample" style="max-width: 600px; margin: 0 auto;">
                                    <v-chip
                                        v-for="item in accessionexamples"
                                        :key="item.id"
                                        outlined
                                        v-on:click="queryAccessions = item.id2 ? [item.id, item.id2] : [item.id]"
                                    >
                                        <b>{{ item.id }}</b><span v-if="item.id2">&nbsp;-&nbsp;<b>{{ item.id2 }}</b></span> &emsp; {{ item.desc }}
                                    </v-chip>
                                    </v-chip-group>
                                </template>
                                </v-tab-item>
                                <!-- <v-tab-item>
                                    <GoAutocomplete
                                        :append-icon="inSearch ? $MDI.ProgressWrench : $MDI.Magnify"
                                        v-model="queryGo"
                                        :disabled="inSearch"
                                        @click:append="searchGo"
                                        @keyup.enter="searchGo"
                                        @change="selectedExample = null"
                                        @keydown="error = null"
                                        :error="error != null"
                                        :error-messages="error ? error : []"
                                        ></GoAutocomplete>

                                    <v-radio-group 
                                        style="
                                            max-width: 400px;
                                            margin: 0 auto;
                                            "
                                        v-model="goSearchType"
                                        inline>
                                        <v-radio name="goSearchType" label="Include lower GO lineage" value="lower" dark></v-radio>
                                        <v-radio name="goSearchType" label="Exact GO term" value="exact" dark ></v-radio>
                                    </v-radio-group>
                                </v-tab-item> -->
                                <!-- Fixme: Taxonomy search is currently broken -->
                                <v-tab-item>
                                    <TaxonomyNcbiSearch
                                        :append-icon="inSearch ? $MDI.ProgressWrench : $MDI.Magnify"
                                        @click:append="searchLCA"
                                        @input="searchLCA"
                                        @keyup.enter="searchLCA"
                                        v-model="queryLCA"
                                        :value="queryLCA ? queryLCA.text : ''"
                                    ></TaxonomyNcbiSearch>
                                    <v-radio-group 
                                        style="
                                            max-width: 400px;
                                            margin: 0 auto;
                                            "
                                        v-model="lcaSearchType"
                                        inline>
                                        <v-radio name="lcaSearchType" label="Include lower LCA lineage" value="lower" dark></v-radio>
                                        <v-radio name="lcaSearchType" label="Exact LCA identifier" value="exact" dark ></v-radio>
                                    </v-radio-group>
                                </v-tab-item>
                                <v-tab-item>
                                    <FoldseekSearchButton @response="searchFoldseek($event)" dark></FoldseekSearchButton>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-text-field
                                        outlined
                                        label="Cluster ID"
                                        style="max-width: 400px; margin: 0 auto;"
                                        v-model="query"
                                        :append-icon="inSearch ? $MDI.ProgressWrench : $MDI.Magnify"
                                        :disabled="inSearch"
                                        @click:append="searchCluster"
                                        @keyup.enter="searchCluster"
                                        @change="selectedExample = null"
                                        @keydown="error = null"
                                        :error="error != null"
                                        :error-messages="error ? error : []"
                                        dark
                                        >
                                    </v-text-field>
                                    
                                    <template>
                                        <h2 class="text-h6 mb-2">
                                            Examples
                                        </h2>
                                        <v-chip-group
                                            column
                                            dark
                                            v-model="selectedExample"
                                            style="max-width: 400px; margin: 0 auto; "
                                        >

                                            <v-chip v-for="item in intcluexamples" :key="item.id"
                                                outlined v-on:click="query=item.id" >
                                                <b>{{ item.id }}</b> &emsp; {{ item.desc }}
                                            </v-chip>
                                        </v-chip-group>
                                    </template>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-col>
                    </v-row>
                </v-parallax>
            </v-flex>
            <SearchResult v-if="tab == 0" @total="small = $event > 0; inSearch = false;"></SearchResult>
            <!-- <GoSearchResult v-else-if="tab == 1" @total="small = $event > 0; inSearch = false;"></GoSearchResult> -->
            <LCASearchResult v-else-if="tab == 1" @total="small = $event > 0; inSearch = false;"></LCASearchResult>
            <FoldseekSearchResult v-else-if="tab == 2" @total="small = $event > 0; inSearch = false;"></FoldseekSearchResult>
            <v-flex>
                <v-card flat>
                    <v-flex>
                    <v-card-title primary-title class="pb-0 mb-0">
                        <div class="text-h5 mb-0">Reference</div>
                    </v-card-title>
                    <v-card-title primary-title class="pt-0 mt-0">
                        
                        <p class="text-subtitle-1 mb-0" style="word-break: break-word;">
                                Strom&nbsp;J.M, Cha&nbsp;S, Kim&nbsp;R.S, Sajal&nbsp;H, Gilchrist&nbsp;CLM, Steinegger&nbsp;M, Luck&nbsp;K. 
                                <a href="https://www.biorxiv.org/content/10.64898/2026.08.24.746585v2\" target="_blank" rel="noopener">
                                Foldseek-Interface reveals a protein interface universe far from complete
                                </a>
                            ,&nbsp;bioRxiv,&nbsp;2026.
                        </p>
                    </v-card-title>
                    </v-flex>
                </v-card>

                <p class="text-subtitle-1 mb-0 collab">
                    Protein Interface Clusters is a collaboration between
                    <a href="https://en.snu.ac.kr/">Seoul National University</a> and the
                    <a href="https://www.imb.de/">Institue of Molecular Biology Mainz</a>
                </p>
                <div style="text-align: center; padding-top: 12px; padding-bottom: 40px;">
                    <a style="margin: 12px" rel="external noopener" target="_blank" href="https://en.snu.ac.kr/" height="128">
                        <img class="logos" src="./assets/snu_logo_opt.svg" height="64"/>
                    </a>
                    <a style="margin: 12px" rel="external noopener" target="_blank" href="https://www.imb.de/" height="128">
                        <img class="logos" src="./assets/imb_logo.png" height="64"/>
                    </a>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Panel from "./Panel.vue";
import GoAutocomplete from "./GoAutocomplete.vue";
import GoSearchResult from "./GoSearchResult.vue";
import FoldseekSearchButton from "./FoldseekSearchButton.vue";
import TaxonomyNcbiSearch from "./TaxonomyNcbiSearch.vue";
import LCASearchResult from "./LCASearchResult.vue";
import FoldseekSearchResult from "./FoldseekSearchResult.vue";
import SearchResult from "./SearchResult.vue";

export default {
    name: "search",
    components: { 
        Panel,
        GoAutocomplete,
        GoSearchResult,
        TaxonomyNcbiSearch,
        LCASearchResult,
        FoldseekSearchButton,
        FoldseekSearchResult,
        SearchResult
    },
    data() {
        return {
            tab: 0,
            query: "9101358",
            queryAccessions: ["5B83"],
            selectedExample: 1,
            accessionexamples: [
                {id:'5B83', desc:'Signaling protein'},
                {id:'P63104', desc:'14-3-3 protein zeta/delta'},
                {id: 'P69924', id2: 'P00452', desc: 'nrdA / nrdB'},
            ],
            intcluexamples: [
                {id:'43749830', desc:'14-3-3 zeta in complex with the human Son of sevenless homolog 1 (SOS1)'},
                {id: '9101358', desc: 'Human Optineurin homodimer'},
            ],
            queryGo: { text: "", value: "" },
            goSearchType: "lower",
            queryLCA: { text: "Homo sapiens", value: "9606", common_name: "human" },
            lcaSearchType: "lower",
            inSearch: false,
            response: null,
            small: false,
            error: null,
        };
    },
    computed: {
        windowHeight() {
            if (this.small && !this.tab == 0) {
                return 500;
            }
            return Math.max(Math.min(920, (window.innerHeight - 48) * 0.9), 500);
        },
    },
    mounted() {
        this.setTab();
    },
    watch : {
        '$route': function(to, from) {
            if (from.path != to.path) {
                this.setTab();
            }
        }
    },
    methods: {
        log(value) {
            console.log(value);
        },
        setTab() {
            if (this.$route.params.go) {
                this.tab = 10;
                this.queryGo = { text: "" + this.$route.params.go, value: this.$route.params.go};
                this.goSearchType = this.$route.params.type;
            } else if (this.$route.params.accession) {
                this.tab = 0;
                this.queryAccessions = [this.$route.params.accession, this.$route.params.accession2].filter(a => a);
            } else if (this.$route.params.taxid) {
                this.tab = 1;
                this.queryLCA = {text: "" + this.$route.params.taxid, value: this.$route.params.taxid};
                this.lcaSearchType = this.$route.params.type;
            } else if (this.$route.params.jobid) {
                this.tab = 2;
            } else {
                this.tab = 10;
            }
        },
        search() {
            const accessions = this.queryAccessions
                .map(a => (a || "").trim())
                .filter(a => a);
            
            if (!accessions.length || accessions.length > 2) return;

            this.inSearch = true;
            this.error = null;
            Promise.all(
                accessions.map(acc => this.$axios.get("/" + encodeURIComponent(acc)))
            )
                .then((res) => {
                    return this.$router.push({
                        name: "accession",
                        params: { 
                            accession: accessions[0],
                            accession2: accessions[1] ? accessions[1] : undefined
                        }
                    });
                })
                .catch((err) => {
                    if (err && err.name === "NavigationDuplicated") {
                        this.inSearch = false;
                        return;
                    }
                    if (err.response && err.response.data && err.response.data.error) {
                        this.error = err.response.data.error;
                    } else {
                        this.error = "Unknown error";
                    }

                    this.inSearch = false;
                });
        },
        searchCluster() {
            this.inSearch = true;
            this.error = null;
            this.$axios.get("/cluster/" + this.query)
                .then(response => {
                    this.$router.push({ name: 'cluster', params: { cluster: response.data.intclu_rep_accession } })
                })
                .catch((err) => {
                    if (err.response && err.response.data && err.response.data.error) {
                        this.error = err.response.data.error;
                    } else {
                        this.error = "Unknown error";
                    }
                })
                .finally(() => {
                    this.inSearch = false;
                });
        },
        searchGo() {
            if (!this.queryGo) {
                return;
            }
            this.inSearch = true;
            this.error = null;
            this.$router.push({
                name: "go",
                params: { go: this.queryGo.value, type: this.goSearchType }
            })
            .catch((error) => {
                if (error && error.name == "NavigationDuplicated") {
                    this.inSearch = false;
                }
            });
        },
        searchLCA() {
            if (!this.queryLCA) {
                return;
            }
            this.inSearch = true;
            this.error = null;
            this.$router.push({
                name: "lca",
                params: { taxid: this.queryLCA.value, type: this.lcaSearchType }
            })
            .catch((error) => {
                if (error && error.name == "NavigationDuplicated") {
                    this.inSearch = false;
                }
            });
        },
        searchFoldseek(jobid) {
            this.inSearch = true;
            this.error = null;
            this.$router.push({
                name: "foldseek",
                params: { jobid: jobid }
            })
            .catch((error) => {
                if (error && error.name == "NavigationDuplicated") {
                    this.inSearch = false;
                }
            });
        }
    }
};
</script>

<style scoped>
#search-container {
    padding:0px;
}
.search-component >>> .v-input--checkbox {
    margin-top: 0px;
}

.search-component >>> .input-group label {
    font-size: 16px;
}

.search-component >>> .v-text-field {
    margin-top: 0px;
    padding-top: 0px;
    margin-bottom: 8px;
}

code {
    font-size: 0.8em;
}

.theme--dark .v-input label {
    color: #FFFFFFB3;
}

.theme--light .v-input label {
    color: #00000099;
}

#search-container >>> .v-slide-group__content {
    justify-content: center;
}

.search-select >>> .v-tabs-bar {
    height: 36px;
}

.search-select >>> .v-tab {
    text-transform: none;
    padding: 0 24px
}
.v-tabs-items {
    background-color: transparent !important;
}

.v-parallax {
    transition: height 0.25s;
}

.hero ::v-deep .v-parallax__image {
  width: 100% !important;
  object-fit: contain !important;
  object-position: right top;
}

.marv-bg-fg {
    /* background: url('./assets/bg-fg-tmp1.png'); */
    background-size: 98% 90%;
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-position: center center;
}

.logos {
    padding: 4px;
    filter: grayscale(100%);
}

.collab {
    text-align: center;
    padding-top: 20px;
    font-weight: lighter;
    line-height: 1.2;
}

.collab a { 
    text-decoration: none;
    font-weight: 400;
    color: #999;
}

@media (prefers-color-scheme: dark) {
    .logos {
        /* padding: 8px; */
        /* filter: brightness(0) invert(1); */
        filter: grayscale(100%) invert();
        /* background-color: #ddd; */
        /* border-radius: 4px; */
    }

    .collab {
        color: #999;
    }
}

</style>
